'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var cachedRoute = []
/**
 * {
 *   route: { Route Component}      // the component of route
 *   rule: { string }               // the rule : ''
 * }
 */

/** add(or delete when rule is null) cached route to array */
;

var put = exports.put = function put(route, rule) {
  var index = 0;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = cachedRoute[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      if (item.route === route) {
        if (rule) {
          item.rule = rule;
        } else {
          cachedRoute.splice(index, 1);
        }

        return;
      }

      index++;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (rule) cachedRoute.push({
    route: route,
    rule: rule
  });
};

var _tempRoute = void 0;

var _tempIsEnd = void 0;
/** check if route is cached */


var isCached = exports.isCached = function isCached(route) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = cachedRoute[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var item = _step2.value;

      if (item.route === route) {
        return true;
      }

      _tempRoute = item.route.context.parent;
      _tempIsEnd = item.rule === 'parent';

      while (_tempRoute) {
        if (_tempRoute === route) {
          return true;
        }

        _tempRoute = _tempIsEnd ? null : _tempRoute.context.parent;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return false;
};

exports.default = {
  put: put,
  isCached: isCached
};